import React from 'react';
import { Bar } from 'react-chartjs-2';
import Loader from '../../common/loader';
import TooltipItem from '../../common/Tooltip';
import { Y_AXIS_SCALES } from '../../common/constant';

const PerformanceGraph = ({
  headText = '',
  tooltipContent = '',
  tooltipPlace = 'left',
  performanceGraphLoader ,
  tooltipOpen,
  barLabel = [],
  usersBarGraphData = [],
  totalUsersBarGraphData = [],
}) => {
  const barGraphData = {
    labels: barLabel,
    datasets: [
      {
        label: 'You',
        backgroundColor: 'rgb(31,140,235)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgb(31,140,235)',
        data: usersBarGraphData,
      },
      {
        label: 'AnalystPrep Users Average',
        backgroundColor: 'rgb(42,63,84)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgb(42,63,84)',
        data: totalUsersBarGraphData,
      },
    ],
  };
  return (
    <div className='card'>
      <div className='card-header'>
        {headText}
        <div className='card-actions card_action_tooltip float-right'>
          <TooltipItem
            key='0'
            tooltipId='0'
            content={tooltipContent}
            tooltipPlace={tooltipPlace}
            tooltipOpen={tooltipOpen}
          />
        </div>
      </div>
      <div className='card-block'>
        <div className={`main_loader  ${performanceGraphLoader ? 'show_block' : 'hide_block'}`}>
          <div className='loader-mid'>
            <div className='card-block-loader'>
              <Loader />
            </div>
          </div>
        </div>
        <div className='chart-wrapper performance-chart-wrapper'>
          {barGraphData.labels && (
            <Bar
              data={barGraphData}
              options={{
                maintainAspectRatio: false,
                ...Y_AXIS_SCALES,
                tooltips: {
                  callbacks: {
                    label(tooltipItem, data) {
                      return `${data.datasets[tooltipItem.datasetIndex].label}: ${
                        tooltipItem.yLabel
                      }%`;
                    },
                  },
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PerformanceGraph;



// WEBPACK FOOTER //
// ./src/Components-2025/dashboard/PerformanceGraph.jsx